<template>
    <b-container fluid class="top-padding bottom-padding no-horiz-padding">

        <h3 style="padding-top:0">Weaving Draft: {{draft.DisplayTitle}}, #{{draft.PatternID}}</h3>

        <subscriber-login-prompt/>

        <hr class="no-vertical-spacing" v-if="isSubscriber" />

        <div class="small-top-padding">
            <b-button v-if="(!viewVisible) && isSubscriber" class='small-bottom-margin' size='sm' variant='secondary' @click='toggleViewButton'>View &raquo;</b-button>
            <b-button v-if="viewVisible && isSubscriber" class='small-bottom-margin' size='sm' variant='dark' @click='toggleViewButton'>View &darr;</b-button>
            <b-button v-if="!actionsVisible" class='small-bottom-margin' size='sm' variant='secondary' @click='toggleActionsButton'>Actions &raquo;</b-button>
            <b-button v-if="actionsVisible" class='small-bottom-margin border-dark' size='sm' variant='dark' @click='toggleActionsButton'>Actions &darr;</b-button>
            <b-button v-if="(!tagsVisible && ((this.allPatternTags.length > 0) || isAuthenticated))" class='small-bottom-margin' size='sm' variant='secondary' @click='toggleTagsButton'>{{tagsButtonTitle}} &raquo;</b-button>
            <b-button v-if="tagsVisible" class='small-bottom-margin border-dark' size='sm' variant='dark' @click='toggleTagsButton'>{{tagsButtonTitle}} &darr;</b-button>

            <b-button v-if="(!commentsVisible && ((this.allPatternComments.length > 0) || isAuthenticated))" class='small-bottom-margin' size='sm' variant='secondary' @click='toggleCommentsButton'>{{ commentsButtonTitle }} &raquo;</b-button>
            <b-button v-if="commentsVisible" class='small-bottom-margin border-dark' size='sm' variant='dark' @click='toggleCommentsButton'>{{ commentsButtonTitle }} &darr;</b-button>

            <!--
            <b-button v-if="!profileVisible" class='small-bottom-margin' size='sm' variant='secondary' @click='toggleProfileButton'>Profile &raquo;</b-button>
            <b-button v-if="profileVisible" class='small-bottom-margin border-dark' size='sm' variant='dark' @click='toggleProfileButton'>Profile &darr;</b-button>
            -->
            <share-button/>
            <b-button v-if="isAuthenticated && (!isLiked)" class='small-bottom-margin transparent-border' size='sm' variant='outline-secondary' @click='toggleLikeButton'><span class="glyphicon glyphicon-thumbs-up"></span> Like</b-button>
            <b-button v-if="isAuthenticated && isLiked" class='small-bottom-margin primary-text transparent-border' size='sm' variant='outline-secondary' @click='toggleLikeButton'><span class="glyphicon glyphicon-thumbs-up"></span> Like</b-button>
        </div>
        <div>
            <div v-if="isSubscriber && viewVisible" class="inline-auto-width right-padding align-top">
                Tieup<br />
                <table>
                    <tr>
                        <td class="medium-right-padding"><input type='radio' v-model="orientation" name='orientation' value="tl" /></td>
                        <td class="medium-right-padding"><input type='radio' v-model="orientation" name='orientation' value="tr" /></td>
                    </tr>
                    <tr>
                        <td class="medium-right-padding"><input type='radio' v-model="orientation" name='orientation' value="bl" /></td>
                        <td class="medium-right-padding"><input type='radio' v-model="orientation" name='orientation' value="br" /></td>
                    </tr>
                </table>
            </div>
            <div v-if="isSubscriber && viewVisible" class="inline-auto-width right-padding align-top">
                View Size<br />
                <b-form-select class="form-control" v-model="viewsize" :options='viewsizeOptions'/>
            </div>
            <div v-if="isSubscriber && viewVisible" class="inline-auto-width right-padding align-top">
                <br />
                <input v-if="straightThreadingOptionVisible" v-model="straightThreading" type="checkbox" /><span v-if="straightThreadingOptionVisible">&nbsp;Straight Threading</span><br v-if="straightThreadingOptionVisible" />
                <input v-if="straightTreadlingOptionVisible" v-model="straightTreadling" type="checkbox" /><span v-if="straightTreadlingOptionVisible">&nbsp;Straight Treadling</span><br v-if="straightTreadlingOptionVisible" />
                <input v-if="pointThreadingOptionVisible" v-model="pointThreading" type="checkbox" /><span v-if="pointThreadingOptionVisible">&nbsp;Point Threading</span><br v-if="pointThreadingOptionVisible" />
                <input v-if="pointTreadlingOptionVisible" v-model="pointTreadling" type="checkbox" /><span v-if="pointTreadlingOptionVisible">&nbsp;Point Treadling</span><br v-if="pointTreadlingOptionVisible" />
                <input v-model="turned" type="checkbox" />&nbsp;Turned<br />
                <input v-model="showAsLiftplan" type="checkbox" />&nbsp;Show&nbsp;Liftplan
            </div>

            <div v-if='!isSubscriber' class='small-top-padding'></div>
            
            <div v-if='actionsVisible' class="right-padding align-top small-top-padding">
                <div v-if='isSubscriber || isAuthenticated' class="inline-auto-width top-align">
                    <b-button v-if="isSubscriber" class='small-bottom-margin' variant='outline-secondary' @click='showDownloadDialog'>Download WIF &raquo;</b-button>
                </div>
                <div v-if='this.isAuthenticated' class="inline-auto-width top-align">
                    <b-dropdown variant='outline-secondary' text="Add to Board">
                        <b-dropdown-item @click='addToBoard(clipboard)'>{{ clipboard.Title }}</b-dropdown-item>
                        <b-dropdown-divider v-if='draftBoards && draftBoards.length > 0'/>
                        <b-dropdown-item v-for='board in draftBoards' :key='board.BoardID' @click='addToBoard(board)'>{{ board.Title }}</b-dropdown-item>
                    </b-dropdown>
                </div> 
                <div class="inline-auto-width top-align">
                    <b-button variant='outline-secondary' class='small-bottom-margin' :to='this.previousDraftDetailPageUrl'>&laquo; Prev</b-button>
                    <b-button variant='outline-secondary' class='small-bottom-margin' :to='this.nextDraftDetailPageUrl'>Next &raquo;</b-button>
                </div> 
                <div class="inline-auto-width top-align">
                    <b-button variant='outline-secondary' class="small-bottom-margin" :to='this.collectionDraftPageUrl'>Collection &raquo;</b-button>
                </div>
               <div v-if='matchingThreadingPatternsCount > 1' class="inline-auto-width top-align">
                    <b-button variant='outline-secondary' class="small-bottom-margin" :to='threadingSearchPageUrl'>Same Threading ({{matchingThreadingPatternsCount}} {{(matchingThreadingPatternsCount > 1 ? 'drafts' : 'draft')}}) &raquo;</b-button>
               </div>
               
               <div class="inline-auto-width top-align">
                    <b-button variant='outline-secondary' class="right-margin small-bottom-margin" :to='editDraftPageUrl'>Color &raquo;</b-button>
               </div>
               
            </div>

            <div v-if='tagsVisible && isAuthenticated'>
                <hr/>
                Enter tags to help identify this draft.  Examples: satin, diamonds, hearts, braided twill...
                <div v-if='this.patternTags.length > 0' class='small-vertical-padding'>
                    <span class='bold-prompt'>Your tags for this draft</span> (click to remove):
                    <br/>
                    <b-button :key='tag.PatternTagID' v-for='tag in patternTags' @click='removePatternTagConfirm(tag)' class='padded-button' size='sm' variant='default'><span class='glyphicon glyphicon-tag'/> {{tag.TagName}} &times;</b-button>
                </div>            
                <b-input-group size='sm' class='inputBox'>
                    <vue-bootstrap-typeahead
                        :data="partialMatchTagsList"
                        v-model="tagNameToAdd"
                        class='inputBox'
                        size='sm'
                        :serializer="tag => tag.TagName"
                        placeholder="Enter a new tag for this draft..."
                        @hit="selectedTag = $event"
                        @keydown.native.enter='addNewTag'
                        ref="typeahead"
                    >
                    <template slot="prepend">
                       <b-btn size='sm' variant='primary' @click='addNewTag' type="button">Add Tag</b-btn>
                    </template>
                    </vue-bootstrap-typeahead>
                </b-input-group>
            </div>

            <div class='small-top-padding' v-if='tagsVisible && this.allPatternTags.length > 0'>
                <span class='bold-prompt'>Everyone's tags for this draft</span> (click to see all drafts for each):
                <br/>
                <b-button :key='tag.PatternTagID' v-for='tag in allPatternTags' class='padded-button' :href='tagCollectionPageUrl(tag.TagID, tag.TagName)' size='sm' variant='default'><span class='glyphicon glyphicon-tag'/> {{tag.TagName}} &raquo;</b-button>
            </div>

            <hr v-if='commentsVisible && tagsVisible'>
            <div v-if='commentsVisible'>
                
                <div class='comments-background-color' v-if='this.allPatternComments.length > 0'>
                    <div :key='comment.CommentID' v-for='comment in allPatternComments'>
                        <span class='bold-prompt'>{{ comment.OwnerName }}</span> &bull; <font size='-2'> {{ comment.DateAddedStr }}&nbsp;&nbsp;{{ comment.TimeAddedStr }}</font><br/>
                        {{ comment.CommentText }}
                        <a v-if='isAuthenticated && authUser.UserID === comment.UserID' href='#' @click='removePatternCommentConfirm(comment)'><span class='glyphicon glyphicon-remove'/></a>
                        <hr style='padding-bottom:0; margin-bottom:0'/>
                    </div>
                </div>
                <div v-if='isAuthenticated'>
                    <b-input-group size='sm' class='inputBox vertical-margins'>
                        <b-form-textarea v-model='comment' placeholder='Enter a comment about this draft...' rows='2' max-rows='7' />
                    </b-input-group>
                    <div style='margin-top: 1em'>
                        <b-btn size='sm' variant='primary' @click='addNewComment' type="button">Add Comment</b-btn>
                    </div>
                </div>
            </div>

            <hr v-if='profileVisible && tagsVisible || commentsVisible'>
            <div v-if='profileVisible'>
                <div class='smallTopPadding' >
                    <b-button variant='outline-secondary' class='small-bottom-margin' :to='this.profileDraftPageUrl'> Profile Draft &raquo;</b-button>
                </div>
            </div>

        </div>

        <div class="vertical-padding">
            <img v-if='!isMobileDevice' class="right-padding" :src="currentDraftImageUrl" :alt="'draft image:' + draft.Tooltip" />
            <!-- 
                fixes a bug on mobile webkit browsers where a large image actually increases the window size beyond the screen width to support horizontal scrolling,
                causing the Bootstrap have bar hamburger to push out to beyond the right side of the display, becoming invisible without scrolling
             -->
            <img v-if='isMobileDevice' style='max-width: 100%' class="right-padding" :src="currentDraftImageUrl" :alt="'draft image:' + draft.Tooltip" />
        </div>

        <div>
            <div class="small-top-padding right-padding" style="display: inline-block;">
                <table style="width: auto" class="table table-bordered">
                    <tr>
                        <td class='greylabel' style="text-align: center">{{draft.Shafts}} Shafts, {{draft.Treadles}} Treadles</td>
                        <td style="text-align: center">Single Pattern Unit</td>
                        <td style="text-align: center">Repeats Shown</td>
                    </tr>
                    <tr>
                        <td style="text-align: right">Threading</td>
                        <td class='greylabel' style="text-align: center">{{draft.WarpUnitThreads}}</td>
                        <td class='greylabel' style="text-align: center">{{draft.WarpRepeatsShown}}</td>
                    </tr>
                    <tr>
                        <td style="text-align: right">Treadling</td>
                        <td class='greylabel' style="text-align: center">{{draft.WeftUnitThreads}}</td>
                        <td class='greylabel' style="text-align: center">{{draft.WeftRepeatsShown}}</td>
                    </tr>
                </table>
            </div>

            <div class="small-top-padding" style="display: inline-block;">

                <table style="width: auto" class="table table-bordered">
                    <tr>
                        <td style="text-align: center">Maximum Floats</td>
                        <td style="text-align: center">Front</td>
                        <td style="text-align: center">Back</td>
                    </tr>
                    <tr>
                        <td style="text-align: right">Warp</td>
                        <td class='greylabel' style="text-align: center">{{draft.MaxFrontWarpFloat}}</td>
                        <td class='greylabel' style="text-align: center">{{draft.MaxBackWarpFloat}}</td>
                    </tr>
                    <tr>
                        <td style="text-align: right">Weft</td>
                        <td class='greylabel' style="text-align: center">{{draft.MaxFrontWeftFloat}}</td>
                        <td class='greylabel' style="text-align: center">{{draft.MaxBackWeftFloat}}</td>
                    </tr>
                </table>
            </div>

            <div v-if='matchingThreadingPatternsCount <= 1'>
                <span>&nbsp;&nbsp;(no other drafts share this threading)</span>
            </div >
        </div>
        

        <div class="top-padding">
            Provided By: {{draft.ContributedByName}}
        </div>

        <div v-if="draft.Notes && draft.Notes.length > 0" class="top-padding">
            Notes:<br/><br/>
            <div v-html="draft.Notes"/>
        </div>

        <h3 class='top-padding'>Source Collection</h3>

        <div>
            
            <router-link :to='this.collectionDraftPageUrl' :title='this.collection.TitleWithAuthors'>
                <img align='left' class='cover-image bottom-padding right-padding' :src='this.collectionCoverImageUrl' :alt='"Collection Cover Image Image for:" + this.collection.TitleWithAuthors'/>
            </router-link>
            
            <router-link :to='this.collectionDraftPageUrl' :title='this.collection.TitleWithAuthors'>
                <h3 style='display: inline' class="no-top-spacing">{{this.collection.TitleWithAuthors}}</h3>
            </router-link>

            <p v-if="collection.Description">
                <span v-html='collection.Description'/>
                <br />
            </p>

            <p v-if="this.collection.OriginalSourceLinkUrl">
                <a target='_blank' :href='collection.OriginalSourceLinkUrl'>{{collection.OriginalSourceLinkText}}</a>
                <br />
            </p>

            <p>
                <b-button variant='primary' :to='this.collectionDraftPageUrl'>Browse Collection, {{collection.TotalPatterns}} Drafts &raquo;</b-button>
            </p>
        </div>
        
        <div style='clear: both'>
            <related-store-products :collectionId = 'draft.BookID'></related-store-products>
        </div>

        <help-us-button/>
        <mail-chimp-signup/>

        <b-modal auto-focus-button='cancel' ref='boardAddedModalRef' title='Draft Added to Board' ok-title='View Draft Board »' @ok='handleGoToBoard' cancel-title='Not Now' @cancel='handleBoardContinue' :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                This draft was added to your {{ addedToBoardPrompt }}.  Would you like to view this now?
            </div>
        </b-modal>

        <b-modal ref='downloadModalRef' title='Choose WIF Type for Download' :ok-only='true' ok-title='Cancel' ok-variant='secondary' :no-close-on-backdrop='true' :no-close-on-esc='true' @ok='showDownloadDialog(false)'>
            <div class="d-block text-center">
                Would you like a standard or liftplan-only WIF? Choose standard if unsure.
                <br/>
                <br/>
                <b-button class='small-right-padding' @click='downloadWIF(false)' variant='primary'>Download Standard WIF »</b-button>
                <b-button class='small-left-padding' @click='downloadWIF(true)' variant='primary'>Download Liftplan WIF »</b-button>
            </div>
        </b-modal>

        <b-modal auto-focus-button='cancel' ref='removeTagConfirmModalRef' title='Remove Tag?' ok-title='Remove »' @ok='handleRemoveTag' cancel-title='Cancel' @cancel='handleRemoveTagCancel' :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                Would you like to remove your tag &quot;{{tagToRemove.TagName}}&quot; from this draft?
            </div>
        </b-modal>
        <b-modal auto-focus-button='cancel' ref='removeCommentConfirmModalRef' title='Remove Comment?' ok-title='Remove »' @ok='handleRemoveComment' cancel-title='Cancel' @cancel='handleRemoveCommentCancel' :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                Would you like to remove your comment &quot;{{commentToRemove.CommentText.substr(0, 25) + '...'}}&quot; from this draft?
            </div>
        </b-modal>    

    </b-container>
</template>

<script>
import dataService from '../mixins/dataService.js'
import mediaService from '../mixins/mediaService.js'
import urlsService from '../mixins/urlsService.js'
import helpUsButton from './HelpUsButton.vue'
import mailChimpSignup from './MailChimpSignup.vue'
import relatedStoreProducts from './RelatedStoreProducts.vue'
import subscriberLoginPrompt from './SubscriberLoginPrompt.vue'
import utilityService from '../mixins/utilityService.js'
import cfg from '../config/config.js'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import shareButton from './ShareButton.vue'

let determineOptimalDraftDisplaySizeFunction

let MAX_RETHREAD_COUNT = 64

const emptyDraft = {
    'PatternID': 0,
    'BookID': 0,
    'BookTitleWithAuthors': '',
    'PatternTitle': '',
    'Tooltip': '',
    'DisplayTitle': '',
    'CommonNames': '',
    'Shafts': 0,
    'Treadles': 0,
    'WarpThreads': 0,
    'WeftThreads': 0,
    'EnteredByUserID': 0,
    'ApprovedByUserID': 0,
    'ApprovalDate': '0001-01-01T00:00:00',
    'OriginalSource': '',
    'AreaOfOrigin': '',
    'TimePeriod': '',
    'DateEntered': '0001-01-01T00:00:00',
    'Notes': '',
    'OriginalFilename': '',
    'IsActive': true,
    'WIFData': '',
    'PrivateNotes': '',
    'ContributorSerial': '',
    'WarpUnitThreads': 0,
    'WeftUnitThreads': 0,
    'MaxFrontWarpFloat': 0,
    'MaxFrontWeftFloat': 0,
    'MaxBackWarpFloat': 0,
    'MaxBackWeftFloat': 0,
    'WarpRepeatsShown': 0,
    'WeftRepeatsShown': 0,
    'ImagesExist': true,
    'ContributedByName': ''
}

const emptyCollection = {
    'BookID': 0,
    'Title': '',
    'IsActive': true,
    'Description': '',
    'Authors': '',
    'TitleWithAuthors': '',
    'PublicationDate': '',
    'ISBN': '',
    'LC': '',
    'CoverPhotoName': '',
    'PublisherName': '',
    'TotalPatterns': 0,
    'IndexItemCount': 0,
    'OriginalSourceLinkUrl': '',
    'OriginalSourceLinkText': ''
}

export default {
    mixins: [dataService, mediaService, urlsService, utilityService],
    data: function() {
        return {
            orientation: 'tl',
            orientationInitialized: false,
            viewsize: 4,
            straightThreading: false,
            straightTreadling: false,
            pointThreading: false,
            pointTreadling: false,
            turned: false,
            showAsLiftplan: false,
            draft: emptyDraft,
            previousDraft: emptyDraft,
            nextDraft: emptyDraft,
            collection: emptyCollection,
            collectionPageNumber: 0,
            previousDraftDetailPageUrl: '#',
            nextDraftDetailPageUrl: '#',
            collectionDraftPageUrl: '#',
            collectionFirstPageUrl: '#',
            collectionCoverImageUrl: '#',
            threadingSearchPageUrl: '#',
            profileDraftPageUrl: '#',
            draftHasPointCompatibleThreading: false,
            draftHasPointCompatibleTreadling: false,
            viewsizeOptions: [
                { value: 2, text: 'smallest' },
                { value: 3, text: 'smaller' },
                { value: 4, text: 'small' },
                { value: 5, text: 'medium' },
                { value: 7, text: 'large' },
                { value: 9, text: 'larger' },
                { value: 11, text: 'largest' }
            ],
            windowWidth: 0,
            windowHeight: 0,
            matchingThreadingPatternsCount: 0,
            viewVisible: false,
            actionsVisible: false,
            tagsVisible: false,
            commentsVisible: false,
            profileVisible: false,
            viewButtonPrompt: 'Download WIF &raquo;',
            tagNameToAdd: '',
            partialMatchTagsList: [],
            selectedTag: null,
            patternTags: [],
            allPatternTags: [],
            allPatternComments: [],
            comment: '',
            tagToRemove: { TagID: 0, TagName: 'placeholder' },
            commentToRemove: { CommentID: 0, CommentText: 'placeholder' },
            isLiked: false,
            draftBoards: [],
            clipboard: { BoardID: 0, Title: 'Clipboard', OwnerName: '' },
            addedToBoard: {},
            addedToBoardPrompt: ''
        }
    },
    components: {
        helpUsButton: helpUsButton,
        mailChimpSignup: mailChimpSignup,
        relatedStoreProducts: relatedStoreProducts,
        subscriberLoginPrompt: subscriberLoginPrompt,
        shareButton: shareButton,
        VueBootstrapTypeahead
    },
    methods: {

        debounceTagNameInput() {
            this.debounceInput(function() {
                this.loadMatchingTagsByPartialName()
            }, 500)
        },

        loadMatchingTagsByPartialName() {
            // console.log('in loadMatchingTagsByPartialName')
            let userID = 0 // auto suggest using tags from everyone
            if (this.tagNameToAdd.length > 1) {
                this.getTagsByPartialName(userID, this.tagNameToAdd).then(resp => {
                    // console.log('returned tags list: ' + JSON.stringify(resp.data))
                    this.partialMatchTagsList = resp.data
                })
            }
        },

        tagCollectionPageUrl: function(tagId, tagName) {
            return this.buildMatchingTagsCollectionUrl(tagId, tagName, 'alltags')
        },

        showDownloadDialog(isVisible) {
            isVisible? this.$refs.downloadModalRef.show() : this.$refs.downloadModalRef.hide()
        },

        downloadWIF: function(isLiftplan) {
            this.showDownloadDialog(false)
            this.postAnalytics(this.authUser.UserID, 0, this.draft.PatternID, true).then(resp => {
                let wifDownloadUrl = ''
                if (!this.turned) {
                    wifDownloadUrl = this.getWIFDownloadUrl(this.authUser.UserID, this.authUser.LoginToken, this.draft.PatternID, this.turned, this.straightThreading, this.straightTreadling, this.pointThreading, this.pointTreadling, isLiftplan)
                }
                else {
                    wifDownloadUrl = this.getWIFDownloadUrl(this.authUser.UserID, this.authUser.LoginToken, this.draft.PatternID, this.turned, this.straightTreadling, this.straightThreading, this.pointTreadling, this.pointThreading, isLiftplan)
                }
                window.location.assign(wifDownloadUrl)
            })
        },

        determineOptimalDraftDisplaySize: function() {
            // work around Webkit bug where mobile scrolling sometimes triggers resize event even though window is not resizing
            if (window.innerWidth !== this.windowWidth) {
                this.viewsize = this.calculateDraftInitialDisplaySize(this.draft, window.innerWidth, false)
                this.windowWidth = window.innerWidth
                this.windowHeight = window.innerHeight
            }
        },

        addToBoard(board) {
            if (this.isAuthenticated) {
                this.addedToBoard = board
                if (board.BoardID===0) {
                    this.addedToBoardPrompt = 'draft clipboard'
                    this.postClipboardPattern(this.authUser.UserID, this.draft.PatternID, this.authUser.LoginToken).then(resp => {
                        this.showAddedToBoardDialog(true)
                    })
                }
                else {
                    this.addedToBoardPrompt = 'board: ' + board.Title
                    this.addUserBoardPattern(board.BoardID, this.draft.PatternID, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                        this.showAddedToBoardDialog(true)
                    })
                }
            }
        },

        showAddedToBoardDialog(isShow) {
            isShow ? this.$refs.boardAddedModalRef.show() : this.$refs.boardAddedModalRef.hide()
        },

        handleGoToBoard() {
            if (this.addedToBoard.BoardID === 0) {
                this.$router.push({ name: 'DraftSearch', params: { searchType: 'clipboard' } })
            }
            else {
                let sanitizedTitle = this.sanitizeUrlSegment(this.addedToBoard.Title)
                this.$router.push({ name: 'DraftSearch', params: { searchType: 'board', bookOrCategoryId: this.addedToBoard.BoardID, collectionTitle: sanitizedTitle } })
            }
        },

        handleBoardContinue() {
            this.showAddedToBoardDialog(false)
        },

        hasBlockProfile() {
            return this.draft && (this.draft.ProfileShafts > 1 || this.draft.ProfileTreadles > 1)
        },

        flipThreadingOptionsUponTurned() {
            if (this.straightThreading !== this.straightTreadling) {
                let formerStraightThreading = this.straightThreading
                this.straightThreading = this.straightTreadling
                this.straightTreadling = formerStraightThreading
            }
            if (this.pointThreading !== this.pointTreadling) {
                let formerPointThreading = this.pointThreading
                this.pointThreading = this.pointTreadling
                this.pointTreadling = formerPointThreading
            }
        },

        loadDraftData() {
            let draftId = this.$route.params.id
            this.getPattern(draftId).then(resp => {
                this.draft = resp.data
                this.draft.Notes = this.draft.Notes.split('\\n').join('<br />')
                this.$store.commit('setPageTitle', 'Weaving Draft ' + this.draft.DisplayTitle + ', #' + this.draft.PatternID)
                this.draftHasPointCompatibleThreading = (this.draft.PointedShafts > 0)
                this.draftHasPointCompatibleTreadling = (this.draft.PointedTreadles > 0)

                if (this.hasBlockProfile()) {
                    this.profileDraftPageUrl = this.buildDraftProfileUrl(this.draft)
                    console.log('has block profile!')
                }
                else {
                    console.log('no block profile')
                }

                // drafts for collection prev and next come in without titles to avoid having to query the entire drafts
                // on the detail page, so add in the title here once we know it by loading the draft for display
                // this saves two network calls on every draft display
                if (!this.$route.params.title) {
                    this.addDisplayTitleToUrl(this.draft)
                }

                this.getCollection(this.draft.BookID).then(resp => {
                    this.collection = resp.data
                    this.determineOptimalDraftDisplaySize()
                    this.getPatternCollectionPositionFiltered(draftId, this.collection.BookID, this.authUserSettings.MinShafts, this.authUserSettings.MaxShafts, this.authUserSettings.MaxTreadles, this.authUserSettings.MaxFloatLength).then(resp => {
                        // console.log('getPatternCollectionPositionFiltered: ' + JSON.stringify(resp))
                        if (resp.data.CollectionPosition > 0) {
                            // pattern is included in user's filter criteria, use previous, next, and collection position data from that
                            this.loadPreviousNextInfo(draftId, resp)
                        }
                        else { // pattern was excluded by user's filter criteria but loaded individually, clear filters and try again
                            this.clearAllFiltersUserSettings()
                            this.getPatternCollectionPositionFiltered(draftId, this.collection.BookID, this.authUserSettings.MinShafts, this.authUserSettings.MaxShafts, this.authUserSettings.MaxTreadles, this.authUserSettings.MaxFloatLength).then(resp => {
                                // console.log('getPatternCollectionPositionFiltered after clearing filters: ' + JSON.stringify(resp))
                                this.loadPreviousNextInfo(draftId, resp)
                            })
                        }
                    })
                })
                this.loadTagsForPattern()
                this.loadCommentsForPattern()
                if (this.isAuthenticated) {
                    this.loadPatternLikes()
                    this.loadUserBoards()
                }
            })
        },

        loadPreviousNextInfo(draftId, resp) {
            let nextDraftId = resp.data.NextPatternID
            let previousDraftId = resp.data.PreviousPatternID
            let collectionPosition = resp.data.CollectionPosition - 1 // sql is 1 based for rownumber, 0 is easier here

            this.collectionPageNumber = Math.floor(collectionPosition / cfg.config.draftResultsPerPage)
            this.collectionDraftPageUrl = this.buildCollectionPageUrl(this.collection, this.collectionPageNumber)
            this.collectionFirstPageUrl = this.buildCollectionPageUrl(this.collection, 0)
            this.collectionCoverImageUrl = this.getCollectionCoverImageUrl(this.collection)

            this.previousDraftDetailPageUrl = this.buildDraftDetailUrl({ PatternID: previousDraftId, DisplayTitle: null })
            this.nextDraftDetailPageUrl = this.buildDraftDetailUrl({ PatternID: nextDraftId, DisplayTitle: null })

            determineOptimalDraftDisplaySizeFunction = this.determineOptimalDraftDisplaySize.bind(this)
            window.addEventListener('resize', determineOptimalDraftDisplaySizeFunction)

            this.postAnalytics(this.authUser.UserID, 0, draftId, false)
            this.loadMatchingThreadingPatternsCount()
        },

        clearAllFiltersUserSettings() {
            if (this.isAuthenticated) {
                let userSettings = this.$store.state.authUserSettings
                // console.log('in clearAllFiltersUserSettings')
                userSettings.MinShafts = 0
                userSettings.MaxShafts = 0
                userSettings.MaxTreadles = 0
                userSettings.MaxFloatLength = 0
                this.$store.commit('setFilters', userSettings)
                // console.log('user settings after clear: ' + JSON.stringify(userSettings))
                this.putUserSettings(this.authUser.UserID, userSettings, this.authUser.LoginToken)
            }
        },

        loadMatchingThreadingPatternsCount() {
            if (this.draft.PatternID > 0) {
                return this.getMatchingThreadingPatternsCount(this.draft.PatternID, 0, this.turned, this.straightThreading, this.pointThreading).then(resp => {
                    this.matchingThreadingPatternsCount = resp.data
                    this.threadingSearchPageUrl = this.buildMatchingThreadingsCollectionUrl(this.draft.PatternID, 0, this.turned, this.straightThreading, this.pointThreading, 0, 0)
                })
            }
            else {
                this.matchingThreadingPatternsCount = 0
                this.threadingSearchPageUrl = '#'
            }
        },

        loadTagsForPattern() {
            // console.log('in load tags for pattern 1')
            this.getPatternTags(this.draft.PatternID, 0).then(resp => {
                // console.log('in load all tags for pattern 2')
                this.allPatternTags = resp.data
                // console.log('loaded allPatternTags = ' + JSON.stringify(this.allPatternTags))
                if (this.isAuthenticated) {
                    this.getPatternTags(this.draft.PatternID, this.authUser.UserID).then(resp => {
                        // console.log('in load tags for pattern 3')
                        this.patternTags = resp.data
                        // console.log('loaded patternTags = ' + JSON.stringify(this.allPatternTags))
                    })
                }
            })
        },

        loadCommentsForPattern() {
            // console.log('in load comments for pattern 1')
            this.getPatternComments(this.draft.PatternID).then(resp => {
                // console.log('in load all comments for pattern 2')
                this.allPatternComments = resp.data
            })
        },

        loadPatternLikes() {
            this.getPatternLikes(this.draft.PatternID, this.authUser.UserID).then(resp => {
                let likesArray = resp.data
                this.isLiked = (likesArray && likesArray.length > 0)
            })
        },

        loadUserBoards() {
            this.getUserBoards(this.authUser.UserID).then(resp => {
                this.draftBoards = resp.data
            })
        },

        toggleViewButton() {
            this.viewVisible = !this.viewVisible
            // this.actionsVisible = false
            // this.tagsVisible = false
        },

        toggleInfoButton() {
            this.actionsVisible = false
            // this.viewVisible=false
            // this.tagsVisible = false
        },

        toggleActionsButton() {
            this.actionsVisible = !this.actionsVisible
            // this.viewVisible=false
            // this.tagsVisible = false
        },

        toggleProfileButton() {
            this.profileVisible = !this.profileVisible
            // this.viewVisible=false
            // this.tagsVisible = false
        },

        toggleTagsButton() {
            // console.log('in toggleTagsButton, currently visible = ' + this.tagsVisible)
            this.tagsVisible = !this.tagsVisible
            // this.actionsVisible = false
            // this.viewVisible=false
        },

        toggleCommentsButton() {
            // console.log('in toggleTagsButton, currently visible = ' + this.tagsVisible)
            this.commentsVisible = !this.commentsVisible
            // this.actionsVisible = false
            // this.viewVisible=false
        },

        toggleLikeButton() {
            // console.log('in toggleLikeButton, currently visible = ' + this.tagsVisible)
            this.isLiked = !this.isLiked
            if (this.isLiked) {
                // console.log('about to add like')
                this.addPatternLike(this.draft.PatternID, this.authUser.UserID, this.authUser.LoginToken)
            }
            else {
                // console.log('about to remove like')
                this.removePatternLike(this.draft.PatternID, this.authUser.UserID, this.authUser.LoginToken)
            }
        },

        addNewTag() {
            // console.log('in addNewTag')
            this.addPatternTag(this.draft.PatternID, this.tagNameToAdd, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                this.loadTagsForPattern()
                this.tagNameToAdd = ''
                // works around a bug in vue-bootstrap-typeahead per https://stackoverflow.com/questions/53511539/default-v-model-value-in-vue-bootstrap-typeahead
                this.$refs.typeahead.inputValue = ''
            })
        },

        addNewComment() {
            // console.log('in addNewTag')
            this.addPatternComment(this.draft.PatternID, this.comment, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                this.loadCommentsForPattern()
                this.comment = ''
            })
        },

        removePatternTagConfirm(tag) {
            // console.log('in removePatternTagConfirm, tag: ' + JSON.stringify(tag))
            this.tagToRemove = tag
            this.showRemoveTagDialog(true)
        },

        removePatternCommentConfirm(comment) {
            // console.log('in removePatternCommentConfirm, comment: ' + JSON.stringify(comment))
            this.commentToRemove = comment
            this.showRemoveCommentDialog(true)
        },

        showRemoveCommentDialog(isShow) {
            isShow ? this.$refs.removeCommentConfirmModalRef.show() : this.$refs.removeCommentConfirmModalRef.hide()
        },

        showRemoveTagDialog(isShow) {
            isShow ? this.$refs.removeTagConfirmModalRef.show() : this.$refs.removeTagConfirmModalRef.hide()
        },

        handleRemoveTag() {
            this.removePatternTag(this.draft.PatternID, this.tagToRemove.TagID, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                this.loadTagsForPattern()
                this.showRemoveTagDialog(false)
            })
        },

        handleRemoveTagCancel() {
            this.showRemoveTagDialog(false)
        },

        handleRemoveComment() {
            this.removePatternComment(this.commentToRemove.CommentID, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                this.loadCommentsForPattern()
                this.showRemoveCommentDialog(false)
            })
        },

        handleRemoveCommentCancel() {
            this.showRemoveCommentDialog(false)
        },

        // drafts for collection prev and next come in without titles to avoid having to query the entire drafts
        // on the detail page, so add in the title here once we know it by loading the draft for display
        // this saves two network calls on every draft display

        addDisplayTitleToUrl(displayDraft) {
            let displayTitle = this.sanitizeUrlSegment(displayDraft.DisplayTitle)
            this.$router.replace({ params: { title: displayTitle } })
        }

    },

    watch: {
        '$route.params.id': function() {
            this.loadDraftData()
        },
        'authUser': function() {
            this.loadDraftData()
        },
        'orientation': function() {
            if (this.isAuthenticated) {
                if (this.orientation !== this.authUserSettings.Orientation) {
                    this.putUserSettings(this.authUser.UserID, this.authUserSettings, this.authUser.LoginToken)
                    this.$store.commit('setPreferredTieupOrientation', this.orientation)
                }
            }
        },
        'turned': function() {
            this.flipThreadingOptionsUponTurned()
            this.loadMatchingThreadingPatternsCount()
        },
        'straightThreading': function() {
            if (this.straightThreading) {
                this.pointThreading = false
            }
            this.loadMatchingThreadingPatternsCount()
        },
        'straightTreadling': function() {
            if (this.straightTreadling) {
                this.pointTreadling = false
            }
            this.loadMatchingThreadingPatternsCount()
        },
        'pointThreading': function() {
            if (this.pointThreading) {
                this.straightThreading = false
            }
            this.loadMatchingThreadingPatternsCount()
        },
        'pointTreadling': function() {
            if (this.pointTreadling) {
                this.straightTreadling = false
            }
            this.loadMatchingThreadingPatternsCount()
        },
        'tagNameToAdd': function() {
            this.debounceTagNameInput()
        }
    },

    computed: {
        isSubscriber: function() {
            return this.$store.getters.isSubscriber
        },

        isAuthenticated: function() {
            return this.$store.getters.isAuthenticated
        },

        authUser: function() {
            return this.$store.state.authUser
        },

        authUserSettings: function() {
            return this.$store.state.authUserSettings
        },

        draftImageUrlFunction: function() {
            return this.$store.state.draftImageUrlFunction
        },

        tagsButtonTitle: function() {
            if (this.allPatternTags.length===0) {
                return 'Tags'
            }
            else {
                return 'Tags (' + this.allPatternTags.length + ')'
            }
        },

        commentsButtonTitle: function() {
            if (this.allPatternComments.length===0) {
                return 'Comments'
            }
            else {
                return 'Comments (' + this.allPatternComments.length + ')'
            }
        },

        currentDraftImageUrl: function() {
            if (this.draft.PatternID > 0) {
                let draftImageUrl = ''
                if (!this.turned) {
                    draftImageUrl = this.draftImageUrlFunction(this.draft.PatternID, this.viewsize, this.currentOrientation, this.turned, this.straightThreading, this.straightTreadling, this.pointThreading, this.pointTreadling, this.draft.IsStraightThreading, this.draft.IsStraightTreadling, this.draft.IsPointThreading, this.draft.IsPointTreadling, this.showAsLiftplan, this.draft.ImagesExist)
                }
                else {
                    draftImageUrl = this.draftImageUrlFunction(this.draft.PatternID, this.viewsize, this.currentOrientation, this.turned, this.straightTreadling, this.straightThreading, this.pointTreadling, this.pointThreading, this.draft.IsStraightThreading, this.draft.IsStraightTreadling, this.draft.IsPointThreading, this.draft.IsPointTreadling, this.showAsLiftplan, this.draft.ImagesExist)
                }
                // console.log('Draft Image Url: ' + draftImageUrl)
                return draftImageUrl
            }
            else return '#'
        },

        currentOrientation: function() {
            if (this.$store.getters.isSubscriber) {
                if (!this.orientationInitialized) {
                    this.orientation = this.$store.state.authUserSettings.Orientation
                    this.orientationInitialized = true
                }
            }
            return this.orientation
        },

        isMobileDevice: function() {
            return this.currentDeviceIsMobile()
        },

        pointThreadingOptionVisible() {
             // // console.log('in pointThreadingOptionVisible: ' + JSON.stringify(this.draft))
            return (!this.turned && this.draftHasPointCompatibleThreading && !this.draft.IsPointThreading && this.draft.PointedShafts <= MAX_RETHREAD_COUNT) || (this.turned && this.draftHasPointCompatibleTreadling && !this.draft.IsPointTreadling && this.draft.PointedTreadles <= MAX_RETHREAD_COUNT)
        },

        pointTreadlingOptionVisible() {
            // // console.log('in pointTreadlingOptionVisible: ' + JSON.stringify(this.draft))
            if (this.showAsLiftplan) {
                return false
            }
            return (!this.turned && this.draftHasPointCompatibleTreadling && !this.draft.IsPointTreadling && this.draft.PointedTreadles <= MAX_RETHREAD_COUNT) || (this.turned && this.draftHasPointCompatibleThreading && !this.draft.IsPointThreading && this.draft.PointedShafts <= MAX_RETHREAD_COUNT)
        },

        straightThreadingOptionVisible() {
            return (!this.turned && !this.draft.IsStraightThreading && this.draft.StraightenedShafts <= MAX_RETHREAD_COUNT) || (this.turned && !this.draft.IsStraightTreadling && this.draft.StraightenedTreadles <= MAX_RETHREAD_COUNT)
        },

        straightTreadlingOptionVisible() {
            if (this.showAsLiftplan) {
                return false
            }
            return (!this.turned && !this.draft.IsStraightTreadling && this.draft.StraightenedTreadles <= MAX_RETHREAD_COUNT) || (this.turned && !this.draft.IsStraightThreading && this.draft.StraightenedShafts <= MAX_RETHREAD_COUNT)
        },

        editDraftPageUrl() {
            return this.buildEditDraftUrl(this.$route.params.id, this.turned, this.straightThreading, this.straightTreadling, this.pointThreading, this.pointTreadling)
        }

    },
    created() {
        this.loadDraftData()
    },
    destroyed() {
        window.removeEventListener('resize', determineOptimalDraftDisplaySizeFunction)
    }
}
</script>

<style scoped>
    .cover-image {
        max-width: 30%;
        vertical-align: top
    }
    .thick-border {
        border-width: 2px;
    }

    .btn:focus, .btn:active {
        outline: none !important;
        box-shadow: none;
    } 

    input:focus, input:active {
        outline: none !important;
        box-shadow: none;
    } 

    .padded-button {
        margin-right: 0.3rem;
        margin-bottom: 0.3rem;
        background-color: #f0f0f0;
    }

    .padded-button:hover {
        background-color: #dfdfdf;
    }

    .inputBox {
        width: 100%;
        padding-top: 0.2rem;
    }

    .greylabel {
        background-color: rgb(249, 248, 245);
    }

    .bold-prompt {
        font-weight: bold;
    }

    .primary-text {
        color: rgb(0, 123, 255);
        background-color: white;
    }
    
    .top-align {
        vertical-align: top
    }

    .comments-background-color {
        background-color: #efefef;
    }

</style>


// WEBPACK FOOTER //
// src/components/DraftDetail.vue